import React from 'react';
import { Pagination } from '@dopomogai/ui';
import type { InvestOfferingListItem } from '@dopomogai/types';
import { AgentInvestCard } from './AgentInvestCard';

type Props = {
  items: InvestOfferingListItem[];
  total: number;
  page: number; // zero-based
  pageSize: number;
  onPageChange: (page: number) => void;
  onInvest: (agentId: string) => void;
  onView: (agentId: string) => void;
};

export function InvestGrid({ items, total, page, pageSize, onPageChange, onInvest, onView }: Props) {
  return (
    <section className="max-w-6xl mx-auto px-6 py-8">
      <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {items.map((it) => (
          <AgentInvestCard key={it.agent_id} item={it} onInvest={onInvest} onView={onView} />
        ))}
      </div>
      <div className="mt-8 flex justify-center">
        <Pagination
          totalCount={total}
          pageSize={pageSize}
          currentPage={page}
          onPageChange={onPageChange}
        />
      </div>
    </section>
  );
}


